<template>
  <!-- eslint-disable vue/camelcase -->
  <div class="settingsPage flex-1 pb-6 px-6 pt-3">
    <!-- Header Section -->
    <div class="bg-background border-b border-border px-8 py-2 -mx-6 mb-6"
      style="margin-left: -1.5rem; margin-right: -1.5rem;">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-xl font-semibold text-foreground mb-0">Agency Settings</h1>
          <p class="text-muted-foreground text-sm mt-1">Configure your agency account and preferences</p>
        </div>
      </div>
    </div>
    <hr class="mb-6">

    <div v-if="user && isMounted" class="px-2">
      <div class="w-full">
        <!-- Modern Tab Buttons -->
        <div role="tablist" aria-orientation="horizontal"
          class="inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground mb-6 modern-tabs"
          tabindex="0" data-orientation="horizontal" style="outline: none;">
          <button type="button" role="tab"
            :aria-selected="($route.hash === '#' || $route.hash === '') ? 'true' : 'false'"
            :data-state="($route.hash === '#' || $route.hash === '') ? 'active' : 'inactive'"
            :class="['inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', ($route.hash === '#' || $route.hash === '') ? 'bg-background text-foreground shadow-sm' : '']"
            :tabindex="($route.hash === '#' || $route.hash === '') ? '0' : '-1'" data-orientation="horizontal"
            @click="$router.push({ name: $route.name, hash: '#' })">
            Settings
          </button>
          <button v-if="showEmailSmsIntegrationsTab" type="button" role="tab"
            :aria-selected="$route.hash === '#texts' ? 'true' : 'false'"
            :data-state="$route.hash === '#texts' ? 'active' : 'inactive'"
            :class="['inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', $route.hash === '#texts' ? 'bg-background text-foreground shadow-sm' : '']"
            :tabindex="$route.hash === '#texts' ? '0' : '-1'" data-orientation="horizontal"
            @click="$router.push({ name: $route.name, hash: '#texts' })">
            Email / SMS integrations
          </button>
          <button v-if="false" type="button" role="tab"
            :aria-selected="$route.hash === '#landing-page' ? 'true' : 'false'"
            :data-state="$route.hash === '#landing-page' ? 'active' : 'inactive'"
            :class="['inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', $route.hash === '#landing-page' ? 'bg-background text-foreground shadow-sm' : '']"
            :tabindex="$route.hash === '#landing-page' ? '0' : '-1'" data-orientation="horizontal"
            @click="$router.push({ name: $route.name, hash: '#landing-page' })">
            Landing Page
          </button>
          <button v-if="false" type="button" role="tab" :aria-selected="$route.hash === '#log' ? 'true' : 'false'"
            :data-state="$route.hash === '#log' ? 'active' : 'inactive'"
            :class="['inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', $route.hash === '#log' ? 'bg-background text-foreground shadow-sm' : '']"
            :tabindex="$route.hash === '#log' ? '0' : '-1'" data-orientation="horizontal"
            @click="$router.push({ name: $route.name, hash: '#log' })">
            Log
          </button>
          <button type="button" role="tab" :aria-selected="$route.hash === '#emails' ? 'true' : 'false'"
            :data-state="$route.hash === '#emails' ? 'active' : 'inactive'"
            :class="['inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', $route.hash === '#emails' ? 'bg-background text-foreground shadow-sm' : '']"
            :tabindex="$route.hash === '#emails' ? '0' : '-1'" data-orientation="horizontal"
            @click="$router.push({ name: $route.name, hash: '#emails' })">
            Emails
          </button>
          <button type="button" role="tab" :aria-selected="$route.hash === '#privacy' ? 'true' : 'false'"
            :data-state="$route.hash === '#privacy' ? 'active' : 'inactive'"
            :class="['inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', $route.hash === '#privacy' ? 'bg-background text-foreground shadow-sm' : '']"
            :tabindex="$route.hash === '#privacy' ? '0' : '-1'" data-orientation="horizontal"
            @click="$router.push({ name: $route.name, hash: '#privacy' })">
            Privacy
          </button>
          <button type="button" role="tab" :aria-selected="$route.hash === '#billing' ? 'true' : 'false'"
            :data-state="$route.hash === '#billing' ? 'active' : 'inactive'"
            :class="['inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', $route.hash === '#billing' ? 'bg-background text-foreground shadow-sm' : '']"
            :tabindex="$route.hash === '#billing' ? '0' : '-1'" data-orientation="horizontal"
            @click="$router.push({ name: $route.name, hash: '#billing' })">
            Billing
          </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- Settings Tab -->
          <div v-show="$route.hash === '#' || $route.hash === ''" class="space-y-6">
            <!-- Account Information -->
            <div class="bg-card rounded-lg border border-border p-6">
              <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="updateForm">
                <form class="settings-form" @submit.prevent="handleSubmit(updateProfile)">
                  <h2 class="text-lg font-semibold mb-4">Account Information</h2>
                  <div class="space-y-4">
                    <div class="grid grid-cols-4 gap-4">
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="firstName">First Name</label>
                        <input id="firstName" v-model="user.first_name"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="lastName">Last Name</label>
                        <input id="lastName" v-model="user.last_name"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="phone">Phone Number</label>
                        <VuePhoneNumberInput id="phone" v-model="user.phone_number" :error="phoneError"
                          valid-color="#e2e7f1" class="w-full h-9" @update="setPhone" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="email">Email Address</label>
                        <input id="email" v-model="user.email" type="email"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                  </div>
                    <div class="grid grid-cols-5 gap-4">
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="address">Address</label>
                        <input id="address" v-model="user.address.address"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="city">City</label>
                        <input id="city" v-model="user.address.city"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="state">State</label>
                        <input id="state" v-model="user.address.state"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="zip">Zip</label>
                        <input id="zip" v-model="user.address.zip"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="country">Country</label>
                        <select id="country" v-model="user.address.country"
                          class="h-9 w-full rounded-md border border-input bg-background px-3 text-sm">
                          <option v-for="country in Countries()" :key="country.id" :value="country.iso2">
                            {{ country.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                    <div class="grid grid-cols-2 gap-4">
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="poweredBy">Powered By Company Name</label>
                        <input id="poweredBy" v-model="user.agency.name"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                      <div>
                        <label
                          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                          for="leaderboard">Leaderboard Powered By URL</label>
                        <input id="leaderboard" v-model="user.agency.settings.powered_by_link"
                          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-end mt-6">
                    <button type="submit"
                      class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium bg-foreground hover:bg-foreground/90 text-background h-9 px-6"
                      :disabled="loadingUpdate || (invalid && touched)">
                      <b-spinner v-if="loadingUpdate" small />
                      <span v-else>Save Changes</span>
                    </button>
                  </div>
                </form>
              </ValidationObserver>
            </div>

            <!-- Notifications -->
            <div v-if="user.has_re || user.has_social_review" class="bg-card rounded-lg border border-border p-6">
              <h2 class="text-lg font-semibold mb-4">Notifications</h2>
              <div class="space-y-4">
                <div class="flex items-start justify-between">
                  <div class="space-y-1">
                    <div class="flex items-center gap-2">
                      <label
                        class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium">Initial
                        Searches</label>
                      <span class="text-xs px-2 py-0.5 rounded bg-muted text-muted-foreground">
                        {{ user.agency.settings.notify_initial_searches ? 'Enabled' : 'Disabled' }}
                      </span>
            </div>
                    <p class="text-xs text-muted-foreground max-w-xl">Get notified when a widget visitor performs an
                      initial search. Sends basic business information.</p>
                  </div>
                  <button type="button" role="switch" :aria-checked="user.agency.settings.notify_initial_searches"
                    :data-state="user.agency.settings.notify_initial_searches ? 'checked' : 'unchecked'" value="on"
                    class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
                    :style="user.agency.settings.notify_initial_searches ? 'background-color: #3b82f6;' : 'background-color: #d1d5db;'"
                    @click="toggleNotification('initial_searches')">
                    <span
                      class="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform"
                      :style="user.agency.settings.notify_initial_searches ? 'transform: translateX(1.25rem);' : 'transform: translateX(0);'"></span>
                  </button>
                </div>
                <div class="flex items-start justify-between pt-2 border-t">
                  <div class="space-y-1">
                    <div class="flex items-center gap-2">
                      <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium">New
                        Leads</label>
                      <span class="text-xs px-2 py-0.5 rounded bg-muted text-muted-foreground">
                        {{ user.agency.settings.notify_new_leads ? 'Enabled' : 'Disabled' }}
                      </span>
                    </div>
                    <p class="text-xs text-muted-foreground max-w-xl">Get notified when visitors opt in and become
                      leads. Sends complete contact details and information.</p>
                  </div>
                  <button type="button" role="switch" :aria-checked="user.agency.settings.notify_new_leads"
                    :data-state="user.agency.settings.notify_new_leads ? 'checked' : 'unchecked'" value="on"
                    class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
                    :style="user.agency.settings.notify_new_leads ? 'background-color: #3b82f6;' : 'background-color: #d1d5db;'"
                    @click="toggleNotification('new_leads')">
                    <span
                      class="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform"
                      :style="user.agency.settings.notify_new_leads ? 'transform: translateX(1.25rem);' : 'transform: translateX(0);'"></span>
                  </button>
                </div>
              </div>
              <div v-if="user.has_re || user.has_social_review" class="mt-6 pt-6 border-t">
                <WebHook new-design />
              </div>
            </div>

            <!-- Lead Machine Webhook -->
            <div v-if="user.has_lead_machine" class="bg-card rounded-lg border border-border p-6">
              <h2 class="text-lg font-semibold mb-3">Lead Machine Webhook</h2>
              <WebHook hooktype="leadmachine" new-design />
            </div>

            <!-- Change Password -->
            <div class="bg-card rounded-lg border border-border p-6">
              <h2 class="text-lg font-semibold mb-4">Change Password</h2>
              <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="passwordForm">
                <form @submit.prevent="handleSubmit(changePassword)">
                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label
                        class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                        for="password">Password</label>
                      <input id="password" v-model="password.password" type="password"
                        class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                        </div>
                    <div>
                      <label
                        class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block"
                        for="confirmPassword">Confirm Password</label>
                      <input id="confirmPassword" v-model="password.password_confirmation" type="password"
                        class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9" />
                    </div>
                  </div>
                  <button type="submit"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 px-4 py-2 mt-4 bg-foreground hover:bg-foreground/90 text-background h-9"
                    :disabled="loadingPassword || (invalid && touched)">
                    <b-spinner v-if="loadingPassword" small />
                    <span v-else>Change</span>
                  </button>
                </form>
              </ValidationObserver>
            </div>

            <!-- Users: add users and assign to specific businesses (agency always sees this) -->
            <div class="mb-6">
              <p class="text-sm text-muted-foreground mb-3">Add users and assign them to specific businesses. New users receive a password by email. Change your own password in the <strong>Change Password</strong> section below.</p>
              <ManageTeams v-if="user.role === 'Agency' || user.has_premium_plan" />
            </div>

            <!-- White-label Domain -->
            <div v-if="hasPremiumPlan || isAgencySubscribed" class="bg-card rounded-lg border border-border p-6">
              <h2 class="text-lg font-semibold mb-3">White-label Domain</h2>
              <div class="space-y-3 text-sm">
                <p class="text-muted-foreground">To use your own domain/subdomain, you will need to update your DNS as
                  follows:</p>
                <p class="text-muted-foreground">To use a dedicated top level domain ( e.g. yourdomain.com ), change
                  it's A value to ours: <span class="font-mono">24.199.68.123</span></p>
                <p class="text-muted-foreground">To use a subdomain ( e.g. reviews.yourdomain.com ), create an A record
                  under the domain, like so:</p>
                <div class="bg-muted rounded-md p-3 overflow-x-auto">
                  <table class="w-full text-xs">
                    <tbody>
                      <tr>
                        <td class="pr-8 py-1"><span class="text-muted-foreground">Host Target</span></td>
                        <td class="py-1"><span class="text-muted-foreground">Your Subdomain Value</span></td>
                      </tr>
                      <tr>
                        <td class="pr-8 py-1"><span class="font-mono">reviews.yourdomain.com</span></td>
                        <td class="py-1"><span class="font-mono">24.199.68.123</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
                <p class="text-muted-foreground">You must point your domain to our servers prior to entering in your
                  domain name. Please contact <a href="mailto:support@repuagency.com"
                    class="text-primary hover:underline">support@repuagency.com</a> if the SSL doesn't work on your
                  custom domain in an hour after you submit the request.</p>
            </div>
              <div class="mt-6 space-y-4">
                <div class="flex items-center gap-3">
                  <input id="domain"
                    v-model="domainInput"
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 max-w-xs" placeholder="Enter domain" />
                  <button type="button"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 w-9"
                    @click="deleteDomain">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-trash2 h-4 w-4 text-destructive">
                      <path d="M3 6h18"></path>
                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                      <line x1="10" x2="10" y1="11" y2="17"></line>
                      <line x1="14" x2="14" y1="11" y2="17"></line>
                    </svg>
                  </button>
                  <button type="button"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 py-2 bg-foreground hover:bg-foreground/90 text-background h-9 px-8"
                    @click="updateDomainSettings">
                    Save domain
                  </button>
                </div>
                <!-- Favicon and Logo only shown after a domain is added -->
                <template v-if="hasDomain">
                  <div>
                    <label
                      class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-2 block">Favicon</label>
                    <div class="flex items-center gap-3 flex-wrap">
                      <div v-if="faviconPreview"
                        class="h-12 w-12 flex-shrink-0 rounded border border-border bg-white flex items-center justify-center p-1 overflow-hidden">
                        <img :src="faviconPreview" alt="Favicon" class="max-w-full max-h-full object-contain w-full h-full" />
                      </div>
                      <input ref="faviconInput" type="file" accept="image/*" class="hidden"
                        @change="handleFaviconUpload" />
                      <button type="button"
                        class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground rounded-md px-3 h-8"
                        @click="openFaviconFileInput">
                        Choose File
                      </button>
                      <button v-if="faviconPreview" type="button"
                        class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium text-destructive hover:bg-destructive/10 rounded-md px-3 h-8 border border-border"
                        @click="removeFavicon">
                        Remove
                      </button>
                      <span v-if="faviconFileName" class="text-xs text-muted-foreground">{{ faviconFileName }}</span>
                    </div>
                  </div>
                  <div>
                    <label
                      class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-2 block">Logo</label>
                    <div class="flex items-center gap-3 flex-wrap">
                      <div v-if="logoPreview"
                        class="h-12 w-48 flex-shrink-0 rounded border border-border bg-white flex items-center justify-center p-2 overflow-hidden">
                        <img :src="logoPreview" alt="Logo" class="max-w-full max-h-full object-contain" />
                      </div>
                      <input ref="logoInput" type="file" accept="image/*" class="hidden" @change="handleLogoUpload" />
                      <button type="button"
                        class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground rounded-md px-3 h-8"
                        @click="openLogoFileInput">
                        Choose File
                      </button>
                      <button v-if="logoPreview" type="button"
                        class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium text-destructive hover:bg-destructive/10 rounded-md px-3 h-8 border border-border"
                        @click="removeLogo">
                        Remove
                      </button>
                      <span v-if="logoFileName" class="text-xs text-muted-foreground">{{ logoFileName }}</span>
                    </div>
                  </div>
                </template>
                <p v-else class="text-sm text-muted-foreground">Add and save a domain above to configure favicon and logo.</p>
              </div>
              <div class="flex justify-end mt-4">
                <button type="button"
                  class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 py-2 bg-foreground hover:bg-foreground/90 text-background h-9 px-8"
                  @click="updateDomainSettings">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- API Settings Tab -->
        <div v-if="showEmailSmsIntegrationsTab && $route.hash === '#texts'" class="space-y-4">
          <!-- Stripe API Settings -->
          <div class="bg-card rounded-lg border border-border p-6">
            <h2 class="text-lg font-semibold mb-4">Stripe API Settings</h2>
            <div class="space-y-4">
              <div class="max-w-xl">
                <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block font-medium" for="stripe-api-key">Stripe API Key</label>
                <div class="flex gap-2">
                  <input
                    id="stripe-api-key"
                    v-model="stripeApiKey"
                    :type="showStripeKey ? 'text' : 'password'"
                    :readonly="!editStripeKey"
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1 font-mono text-xs"
                  />
                  <button
                    type="button"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground rounded-md px-3 h-9"
                    @click="showStripeKey = !showStripeKey"
                  >
                    {{ showStripeKey ? 'Hide' : 'Show' }}
                  </button>
                  <button
                    type="button"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground rounded-md px-3 h-9"
                    @click="toggleEditStripeKey"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen h-3.5 w-3.5 mr-1.5">
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                    </svg>
                    Edit
                  </button>
                </div>
                <p class="text-xs text-muted-foreground mt-2">Enter your Stripe secret API key to enable subscription payments</p>
              </div>
            </div>
          </div>

          <!-- Twilio SMS Settings -->
          <div class="bg-card rounded-lg border border-border p-6">
            <h2 class="text-lg font-semibold mb-4">Twilio SMS Settings</h2>
            <div class="grid grid-cols-3 gap-4">
                  <div>
                <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block font-medium">From Number</label>
                <div class="flex">
                  <VuePhoneNumberInput
                    ref="vue_tel"
                    v-model="user.agency.twilio_settings.twilio_number"
                    :default-country-code="defaultCountryCode"
                    valid-color="#e2e7f1"
                    class="w-full h-9"
                    @update="phoneUpdated"
                  />
                </div>
                  </div>
                  <div>
                <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block font-medium">Account SID</label>
                    <div class="flex gap-2">
                  <input
                    v-if="isTwilioDisabled"
                    v-model="formattedTwilioSID"
                    readonly
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1 font-mono text-xs"
                  />
                  <input
                    v-else
                    v-model="user.agency.twilio_settings.twilio_sid"
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1 font-mono text-xs"
                  />
                  <button
                    type="button"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 w-9"
                    @click="isTwilioDisabled = !isTwilioDisabled"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen h-3.5 w-3.5">
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                    </svg>
                      </button>
                    </div>
                  </div>
                  <div>
                <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block font-medium">Auth Token</label>
                    <div class="flex gap-2">
                  <input
                    v-if="isTwilioDisabled"
                    v-model="formattedTwilioToken"
                    readonly
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1 font-mono text-xs"
                  />
                  <input
                    v-else
                    v-model="user.agency.twilio_settings.twilio_token"
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1 font-mono text-xs"
                  />
                  <button
                    type="button"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 w-9"
                    @click="isTwilioDisabled = !isTwilioDisabled"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen h-3.5 w-3.5">
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                    </svg>
                      </button>
                    </div>
                  </div>
                </div>
          </div>

          <!-- SendGrid Email Settings -->
          <div class="bg-card rounded-lg border border-border p-6">
            <h2 class="text-lg font-semibold mb-4">SendGrid Email Settings</h2>
            <div class="grid grid-cols-2 gap-4">
                  <div>
                <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block font-medium">From Email Address</label>
                <input
                  v-model="user.agency.twilio_settings.sendgrid_email_address"
                  type="email"
                  class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9"
                />
                  </div>
                  <div>
                <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block font-medium">API Key</label>
                    <div class="flex gap-2">
                  <input
                    v-if="isSendGridDisabled"
                    v-model="formattedSengridApiKey"
                    readonly
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1 font-mono text-xs"
                  />
                  <input
                    v-else
                    v-model="user.agency.twilio_settings.sendgrid_api_key"
                    class="flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1 font-mono text-xs"
                  />
                  <button
                    type="button"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 w-9"
                    @click="isSendGridDisabled = !isSendGridDisabled"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen h-3.5 w-3.5">
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                    </svg>
                      </button>
                    </div>
                  </div>
                </div>
          </div>

          <!-- OpenAI Configuration -->
          <div v-if="showOpenAiConfiguration" class="bg-card rounded-lg border border-border p-6">
            <h2 class="text-lg font-semibold mb-4">OpenAI Configuration</h2>
            <div>
              <label class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm mb-1.5 block" for="apiKey">API Key</label>
              <div class="flex gap-2">
                <input
                  id="apiKey"
                  v-model="user.agency.settings.openai_api_key"
                  :type="showOpenAIKey ? 'text' : 'password'"
                  class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-9 flex-1"
                />
                <button
                  type="button"
                  class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 w-9"
                  @click="showOpenAIKey = !showOpenAIKey"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye h-4 w-4">
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
                <button
                  type="button"
                  class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 w-9"
                  @click="aiDisabled = !aiDisabled"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen h-4 w-4">
                    <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                  </svg>
                </button>
            </div>
              </div>
                  </div>

          <!-- Save Changes Button -->
                  <div>
            <button
              type="button"
              class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 py-2 bg-foreground hover:bg-foreground/90 text-background h-9 px-6"
              @click="saveAllApiSettings"
            >
              <b-spinner v-if="loadingSave" small />
              <span v-else>Save Changes</span>
            </button>
          </div>
        </div>

        <!-- Emails Tab -->
        <div v-show="$route.hash === '#emails'" class="space-y-6">
          <div class="bg-card rounded-lg border border-border p-6">
            <div v-if="!isZenSocial">
              <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="emailsForm">
                <form class="emails-form" @submit.prevent="handleSubmit(updateEmails)">
                  <div class="row">
                    <div class="col">
                      <label>Email when a lead opts-in</label>
                    </div>
                  </div>
                  <div v-if="user.has_social_review">
                    <div class="row">
                      <div class="col mb-3">
                        <h4>ReplyEngine</h4>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <TextInput v-model="user.agency.settings.email_name" name="email_name" rules="required"
                        margin-bottom="0" placeholder="From Name" label="From Name" />
                    </div>
                    <div class="col-md-6">
                      <TextInput v-model="user.agency.settings.email_address" name="email_address"
                        rules="required|email" margin-bottom="0" placeholder="From Name" label="From Email" />
                    </div>
                  </div>
                  <div v-if="user.has_re" class="row">
                    <div class="col-md-6 mt-3">
                      <TextInput v-model="user.agency.settings.email_subject" name="email_subject" rules="required"
                        margin-bottom="0" placeholder="Subject" label="Subject" />
                    </div>
                  </div>
                  <div v-if="user.has_re" class="row mt-3">
                    <div class="col">
                      <vue2-tinymce-editor :id="'email_message' + user.agency.id"
                        v-model="user.agency.settings.email_message"></vue2-tinymce-editor>
                    </div>
                  </div>
                  <div v-if="false && user.has_social_review">
                    <hr />
                    <div class="row">
                      <div class="col mb-3">
                        <h4>Social Review</h4>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <TextInput v-model="user.agency.settings.sr_email_name" name="sr_email_name" rules="required"
                          margin-bottom="0" placeholder="From Name" label="From Name" />
                      </div>
                      <div class="col-md-6">
                        <TextInput v-model="user.agency.settings.sr_email_address" name="sr_email_address"
                          rules="required|email" margin-bottom="0" placeholder="From Name" label="From Email" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mt-3">
                        <TextInput v-model="user.agency.settings.sr_email_subject" name="sr_email_subject"
                          rules="required" margin-bottom="0" placeholder="Subject" label="Subject" />
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col">
                        <vue2-tinymce-editor :id="'sr_email_message' + user.agency.id"
                          v-model="user.agency.settings.sr_email_message"></vue2-tinymce-editor>
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-end mt-6">
                    <button type="submit"
                      class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium bg-foreground hover:bg-foreground/90 text-background h-9 px-6"
                      :disabled="loadingUpdate || (invalid && touched)">
                      <b-spinner v-if="loadingUpdate" small />
                      <span v-else>Save Changes</span>
                    </button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>

          <!-- Lead Machine Emails (if needed) -->
          <div v-if="user.has_lead_machine" class="bg-card rounded-lg border border-border p-6">
            <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="emailsForm">
              <form class="emails-form" @submit.prevent="handleSubmit(updateLMEmails)">
                <div>
                  <h4 class="text-lg font-semibold mb-4">Lead Machine</h4>
                  <div class="row">
                    <div class="col-md-6">
                      <TextInput v-model="user.agency.settings.lm_email_name" name="lm_email_name" rules="required"
                        margin-bottom="0" placeholder="From Name" label="From Name" />
                    </div>
                    <div class="col-md-6">
                      <TextInput v-model="user.agency.settings.lm_email_address" name="lm_email_address"
                        rules="required|email" margin-bottom="0" placeholder="From Name" label="From Email" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mt-3">
                      <TextInput v-model="user.agency.settings.lm_email_subject" name="lm_email_subject"
                        rules="required" margin-bottom="0" placeholder="Subject" label="Subject" />
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col">
                      <vue2-tinymce-editor :id="'lm_email_message' + user.agency.id"
                        v-model="user.agency.settings.lm_email_message"></vue2-tinymce-editor>
                    </div>
                  </div>
                </div>
                <div class="flex justify-end mt-6">
                  <button type="submit"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium bg-foreground hover:bg-foreground/90 text-background h-9 px-6"
                    :disabled="savingLMEmail || (invalid && touched)">
                    <b-spinner v-if="savingLMEmail" small />
                    <span v-else>Save Changes</span>
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>

          <!-- ZenSocial Emails -->
          <div v-if="isZenSocial" class="bg-card rounded-lg border border-border p-6">
            <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="emailsForm">
              <form class="emails-form" @submit.prevent="handleSubmit(updateZenEmails)">
                <div>
                  <div class="row">
                    <div class="col-md-6">
                      <TextInput v-model="user.agency.settings.zen_email_name" name="From Name" margin-bottom="0"
                        placeholder="From Name" label="From Name" />
                    </div>
                    <div class="col-md-6">
                      <TextInput v-model="user.agency.settings.zen_email_address" name="Email Address"
                        rules="required|email" margin-bottom="0" placeholder="From Name" label="From Email" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mt-3">
                      <TextInput v-model="user.agency.settings.zen_email_subject" name="Subject" rules="required"
                        margin-bottom="0" placeholder="Subject" label="Subject" />
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col">
                      <vue2-tinymce-editor :id="'lm_email_message' + user.agency.id"
                        v-model="user.agency.settings.zen_email_message"></vue2-tinymce-editor>
                    </div>
                  </div>
                </div>
                <div class="flex justify-end mt-6">
                  <button type="submit"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium bg-foreground hover:bg-foreground/90 text-background h-9 px-6"
                    :disabled="savingZenEmail || (invalid && touched)">
                    <b-spinner v-if="savingZenEmail" small />
                    <span v-else>Save Changes</span>
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>

        <!-- SMTP Tab (hidden) -->
        <div v-if="false && !isZenSocial && $route.hash === '#smtp'" class="space-y-6">
          <div class="card">
            <div class="card-body">
              <ValidationObserver v-slot="{ handleSubmit }" ref="smtpForm">
                <form class="smtp-form" @submit.prevent="handleSubmit(updateSmtp)">
                  <div class="row">
                    <div class="col-12">
                      <TextInput v-model="user.agency.smtp.host" name="host" rules="required" margin-bottom="0"
                        placeholder="Host" label="Host" />
                    </div>
                    <div class="col-12 mt-3">
                      <TextInput v-model="user.agency.smtp.port" name="port" rules="required" margin-bottom="0"
                        placeholder="Port" label="Port" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mt-3">
                      <TextInput v-model="user.agency.smtp.username" name="username" rules="required" margin-bottom="0"
                        placeholder="Username" label="Username" />
                    </div>
                    <div class="col-12 mt-3">
                      <TextInput v-model="user.agency.smtp.password" type="password" name="password" rules="required"
                        margin-bottom="0" placeholder="Password" label="Password" />
                    </div>
                    <div class="col-12 mt-3">
                      <label>Encryption</label>
                      <select v-model="user.agency.smtp.encryption" name="encryption" class="form-control">
                        <option value=""></option>
                        <option value="tls">tls</option>
                        <option value="ssl">ssl</option>
                      </select>
                    </div>
                    <div class="col-12 mt-3">
                      <TextInput v-model="user.agency.smtp.from_name" name="from_name" rules="required"
                        margin-bottom="0" placeholder="From Name" label="From Name" />
                    </div>
                    <div class="col-12 mt-3">
                      <TextInput v-model="user.agency.smtp.from_email" name="from_email" rules="required"
                        margin-bottom="0" placeholder="From Email" label="From Email" />
                    </div>
                    <!--                        <div class="col-12 mt-3">
                          <TextInput
                              v-model="user.agency.smtp.encryption"
                              name="password"
                              margin-bottom="0"
                              placeholder="Encryption"
                              label="Encryption"
                          />
                        </div>-->
                  </div>
                  <b-form-group class="float-right text-right mt-3">
                    <b-button variant="primary" class="btn-dark-blue" :disabled="loadingUpdate" type="submit">
                      <b-spinner v-if="loadingUpdate" small />
                      <span v-else>Update</span>
                    </b-button>
                  </b-form-group>
                </form>
              </ValidationObserver>
              <ValidationObserver v-slot="{ handleSubmit }" ref="smtpForm">
                <form class="smtp-form" @submit.prevent="handleSubmit(deleteSmtp)">
                  <b-form-group class="float-left text-right mt-3">
                    <b-button variant="danger" class="danger" :disabled="loadingUpdate" type="submit">
                      <b-spinner v-if="loadingUpdate" small />
                      <span v-else>Delete</span>
                    </b-button>
                  </b-form-group>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
        <!-- Privacy Tab -->
        <div v-show="$route.hash === '#privacy'" class="space-y-6">
          <div class="bg-card rounded-lg border border-border p-6">
            <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="privacyForm">
              <form class="privacy-form" @submit.prevent="handleSubmit(updatePrivacy)">
                <div class="row">
                  <div class="col">
                    <label>
                      Privacy Policy
                    </label>
                    <vue2-tinymce-editor id="privacy-policy"
                      v-model="user.agency.settings.privacy_policy"></vue2-tinymce-editor>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <label>
                      Terms Of Service
                    </label>
                    <vue2-tinymce-editor v-if="privacyReady" :id="'terms-of-service' + user.agency.id"
                      v-model="user.agency.settings.terms_of_service"></vue2-tinymce-editor>
                  </div>
                </div>
                <div class="flex justify-end mt-6">
                  <button type="submit"
                    class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium bg-foreground hover:bg-foreground/90 text-background h-9 px-6"
                    :disabled="loadingUpdate || (invalid && touched)">
                    <b-spinner v-if="loadingUpdate" small />
                    <span v-else>Save Changes</span>
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>

        <!-- Billing Tab -->
        <div v-show="$route.hash === '#billing'" class="space-y-6">
          <div class="bg-card rounded-lg border border-border p-6">
            <SettingsPaymentMethods />
          </div>
        </div>

        <!-- Limits Tab (hidden) -->
        <div v-if="hasPremiumPlan && $route.hash === '#limits'" class="space-y-6">
          <div class="card">
            <div class="card-body">
              <table>
                <tbody>
                  <tr v-if="user.has_re">
                    <td class="align-middle">Monthly Reply Limit</td>
                    <td><input type="number" class="form-control"></td>
                  </tr>
                  <tr v-if="user.has_te">
                    <td class="align-middle">Employee Limit</td>
                    <td><input type="number" class="form-control"></td>
                  </tr>
                  <tr v-if="user.has_social_review">
                    <td class="align-middle">Monthly Post Limit</td>
                    <td><input type="number" class="form-control"></td>
                  </tr>
                  <tr v-if="user.has_social_fusion">
                    <td class="align-middle">Monthly Post Limit</td>
                    <td><input type="number" class="form-control"></td>
                  </tr>
                  <tr v-if="user.has_review_requester">
                    <td class="align-middle">Monthly Text Message Limit</td>
                    <td><input type="number" class="form-control"></td>
                  </tr>
                  <tr v-if="user.has_review_requester">
                    <td class="align-middle">Monthly Email Limit</td>
                    <td><input type="number" class="form-control"></td>
                  </tr>
                  <tr>
                    <td class="align-middle">User Limit</td>
                    <td><input type="number" class="form-control"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import SettingsPaymentMethods from "@components/Agency/PaymentMethods/SettingsPaymentMethods";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
// import PasswordReset from "@components/Common/PasswordReset";
import WebHook from "@components/Common/WebHook";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Countries from "@src/countries";
// import WhiteLabelDomain from "@components/Common/WhiteLabelDomain.vue";
import ManageTeams from "@components/Common/ManageTeams.vue";
export default {
  components: {
    ManageTeams,
    SettingsPaymentMethods,
    Vue2TinymceEditor,
    VuePhoneNumberInput,
    WebHook,
  },
  data() {
    return {
      aiBusy: false,
      aiDisabled: true,
      needsAddress: true,
      showVideoModal: false,
      loadingUpdate: false,
      loadingRemove: null,
      showDomainModal: false,
      privacyReady: false,
      phoneError: false,
      isMounted: false,
      loadingPassword: false,
      password: {
        password: '',
        password_confirmation: ''
      },
      domainInput: '',
      faviconPreview: null,
      faviconFileName: '',
      logoPreview: null,
      logoFileName: '',
      user: {
        phone_number: '',
        address: {
          address: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        },
        agency: {
          name: '',
          whitelabel: {},
          settings: {
            notify_initial_searches: false,
            notify_new_leads: false,
            powered_by_link: ''
          },
          smtp: {},
          twilio_settings: {}
        },
        settings: {
          misc: {
            dashboard_reply_engine_plan: '',
            dashboard_tap_engine_plan: ''
          }
        }
      },
      rawSID: '',
      rawToken: '',
      retrieving_review_request_log: false,
      loadingSave: false,
      savingLMEmail: false,
      savingZenEmail: false,
      isDisabled: true,
      isTwilioDisabled: true,
      isSendGridDisabled: true,
      showStripeKey: false,
      editStripeKey: false,
      showOpenAIKey: false,
      stripeApiKey: '',
      reviewRequestDatatable: {
        items: [],
        columns: [
          { key: 'type', label: 'Type', sortable: true },
          { key: 'front_date', label: 'Sent Date', sortable: true },
          { key: 'sent_to', label: 'Sent To' },
          { key: 'content', label: 'Content' },
        ],
        queries: {
          per_page: 10,
          page: 1,
          status: 'active',
          search: null,
          sort_by: 'created_at',
          sort_desc: false,
        },
      }
    }
  },
  computed: {
    hasPremiumPlan() {
      return this.user.has_premium_plan || this.isAdmin;
    },
    isAgencySubscribed() {
      return this.$store.getters['auth/isAgencySubscribed'];
    },
    isAdmin() {
      return localStorage.getItem('main_access_role') === 'Admin';
    },
    /** Twilio/SendGrid (and related API keys) were gated on has_review_requester only; RepuAgency bundles use has_repu_agency. */
    showEmailSmsIntegrationsTab() {
      const u = this.user;
      if (!u) return false;
      return !!(
        u.has_review_requester ||
        u.has_repu_agency ||
        u.role === 'Agency' ||
        u.has_premium_plan
      );
    },
    /** Social Posting uses OpenAI; RepuAgency accounts may not have has_social_fusion on legacy plans. */
    showOpenAiConfiguration() {
      const u = this.user;
      if (!u) return false;
      return !!(u.has_social_fusion || u.has_repu_agency);
    },
    formattedAIPassword: {
      get() {
        return '*'.repeat(this.user.agency.settings.openai_api_key?.length - 7) + this.user.agency.settings.openai_api_key?.slice(-7);
      },
      set(value) {
      }
    },
    formattedTwilioSID: {
      get() {
        if (this.user.agency.twilio_settings?.twilio_sid && this.user.agency.twilio_settings?.twilio_sid.length > 7) {
          return '*'.repeat(this.user.agency.twilio_settings.twilio_sid?.length - 7) + this.user.agency.twilio_settings.twilio_sid?.slice(-7);
        } else {
          return this.user.agency.twilio_settings?.twilio_sid;
        }
      },
      set(value) {
        this.rawSID = value;
      }
    },
    formattedTwilioToken: {
      get() {
        if (this.user.agency.twilio_settings?.twilio_token && this.user.agency.twilio_settings?.twilio_token.length > 7) {
          return '*'.repeat(this.user.agency.twilio_settings.twilio_token?.length - 7) + this.user.agency.twilio_settings.twilio_token?.slice(-7);
        } else {
          return this.user.agency.twilio_settings?.twilio_token;
        }
      },
      set(value) {
        this.rawToken = value;
      }
    },
    formattedSengridApiKey: {
      get() {
        if (this.user.agency.twilio_settings?.sendgrid_api_key && this.user.agency.twilio_settings?.sendgrid_api_key.length > 7) {
          return '*'.repeat(this.user.agency.twilio_settings.sendgrid_api_key?.length - 7) + this.user.agency.twilio_settings.sendgrid_api_key?.slice(-7);
        } else {
          return this.user.agency.twilio_settings?.sendgrid_api_key;
        }
      },
      set(value) {
        this.user.agency.twilio_settings.sendgrid_api_key = value;
      }
    },
    defaultCountryCode() {
      return this.user.agency?.twilio_settings?.phoneObject?.countryCode ?? 'US';
    },
    reviewRequestLog() {
      return this.$store.getters['reviewRequestLog/all'];
    },
    totalReviewRequestLog() {
      return this.$store.getters['reviewRequestLog/total'];
    },
    hasDomain() {
      if (this.user.agency.domains && this.user.agency.domains.length > 0) return true;
      if (this.user.agency.whitelabel && this.user.agency.whitelabel.domains && this.user.agency.whitelabel.domains.length > 0) return true;
      return false;
    },
  },
  mounted() {
    this.user = Vue.util.extend({}, this.$store.getters['auth/user']);

    // Initialize address if not present
    if (!this.user.address) {
      this.$set(this.user, 'address', {
        address: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      });
    }

    // Initialize agency settings if not present
    if (!this.user.agency.settings) {
      this.$set(this.user.agency, 'settings', {
        notify_initial_searches: false,
        notify_new_leads: false,
        powered_by_link: ''
      });
    }

    if (!this.user.agency.twilio_settings) {
      this.$set(this.user.agency, 'twilio_settings', {
        twilio_sid: null,
        twilio_token: null,
        twilio_number: null,
        sendgrid_api_key: null,
        sendgrid_email_address: null,
        phoneObject: { isValid: false, countryCode: 'US' },
      });
    } else if (!this.user.agency.twilio_settings.phoneObject) {
      this.$set(this.user.agency.twilio_settings, 'phoneObject', { isValid: false, countryCode: 'US' });
    }

    // Initialize domain, favicon, and logo from whitelabel if available
    // Check both user.agency.domains and user.agency.whitelabel.domains for compatibility
    let domain = null;
    if (this.user.agency.domains && this.user.agency.domains.length > 0) {
      domain = this.user.agency.domains[0];
    } else if (this.user.agency.whitelabel && this.user.agency.whitelabel.domains && this.user.agency.whitelabel.domains.length > 0) {
      domain = this.user.agency.whitelabel.domains[0];
    }
    
    if (domain) {
      this.domainInput = domain.domain || '';
      if (domain.favicon_src) {
        this.faviconPreview = domain.favicon_src;
        this.faviconFileName = domain.favicon_src.split('/').pop() || '';
      }
      if (domain.logo_src) {
        this.logoPreview = domain.logo_src;
        this.logoFileName = domain.logo_src.split('/').pop() || '';
      }
    }

    // Initialize Stripe API key if available (masked)
    if (this.user.agency.settings && this.user.agency.settings.stripe_api_key) {
      const key = this.user.agency.settings.stripe_api_key;
      // Show only first 4 and last 4 characters if key is long enough
      if (key.length > 8) {
        this.stripeApiKey = key.substring(0, 4) + '****' + key.substring(key.length - 4);
      } else {
        this.stripeApiKey = key;
      }
    }

    this.setupPrivacy();
    this.isMounted = true;
  },

  methods: {
    updateOpenAiAPIKey() {
      this.aiBusy = true

      let params = {
        openai_api_key: this.user.agency.settings.openai_api_key,
        setting_form: 'openai'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          this.aiBusy = false;
          this.aiDisabled = true;
          // Refresh user data
          this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
          this.$toast.success('OpenAI API key saved successfully');
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.errors) {
            this.$refs.updateForm.setErrors(err.response.data.errors);
          }
          this.aiBusy = false;
          this.$toast.error('Error saving OpenAI API key');
        })
    },
    phoneUpdated(phone) {
      if (!this.user.agency.twilio_settings) {
        this.$set(this.user.agency, 'twilio_settings', {});
      }
      this.$set(this.user.agency.twilio_settings, 'phoneObject', phone);
    },
    isMaskedSecret(value) {
      return typeof value === 'string' && /^\*+[A-Za-z0-9]{1,}$/.test(value);
    },
    buildTwilioSettingsPayload() {
      const stored = this.$store.getters['auth/user']?.agency?.twilio_settings || {};
      const current = this.user.agency.twilio_settings || {};
      const payload = {};

      ['sendgrid_email_address', 'sendgrid_api_key'].forEach((field) => {
        let value = current[field] ?? stored[field];
        if (field === 'sendgrid_api_key' && this.isMaskedSecret(value) && stored[field]) {
          value = stored[field];
        }
        if (value) {
          payload[field] = value;
        }
      });

      const hasTwilioInForm = Boolean(
        current.twilio_number || current.twilio_sid || current.twilio_token
      );
      if (hasTwilioInForm) {
        ['twilio_number', 'twilio_sid', 'twilio_token'].forEach((field) => {
          let value = current[field] ?? stored[field];
          if ((field === 'twilio_sid' || field === 'twilio_token') && this.isMaskedSecret(value) && stored[field]) {
            value = stored[field];
          }
          if (value) {
            payload[field] = value;
          }
        });
        payload.phoneObject = current.phoneObject?.e164
          ? current.phoneObject
          : stored.phoneObject;
      }

      return payload;
    },
    twilioSettingsErrorMessage(err) {
      const errors = err?.response?.data?.errors;
      if (errors) {
        const first = Object.values(errors).flat()[0];
        if (first) {
          return first;
        }
      }
      return err?.response?.data?.message || 'Error saving settings';
    },
    onReviewRequestLogPageChanged(page) {
      this.reviewRequestDatatable.queries.page = page
      this.getReviewRequestLog();
    },
    getReviewRequestLog() {
      this.retrieving_review_request_log = true;
      this.$store
        .dispatch(`reviewRequestLog/getAll`, {
          queries: this.reviewRequestDatatable.queries,
          page: 'logs',
          businessId: null,
          agencyId: this.user.agency.id
        })
        .then((resp) => {
          this.retrieving_review_request_log = false;
        })
        .catch((err) => {
          this.retrieving_review_request_log = false;
          console.error(err);
        })
    },
    Countries() {
      return Countries
    },
    setPhone(phone) {
      // this.userPhone = phone.formatInternational;
    },
    async setupPrivacy() {
      // this is stupid but tinymce is creating muliple editors with the same id because they are init at the same time
      await new Promise(resolve => setTimeout(resolve, 500));
      this.privacyReady = true;
    },
    openVideoModal() {
      this.showVideoModal = true
    },

    updateProfile() {
      this.loadingUpdate = true
      this.phoneError = false;
      let params = {
        company_name: this.user.agency.name,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone_number,
        email: this.user.email,
        address: this.user.address,
        notify_initial_searches: this.user.agency.settings.notify_initial_searches,
        notify_new_leads: this.user.agency.settings.notify_new_leads,
        powered_by_link: this.user.agency.settings.powered_by_link,
        setting_form: 'settings'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          this.loadingUpdate = false;
          // Refresh user data from store
          this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
          this.$toast.success('Settings saved successfully');
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.errors) {
            this.$refs.updateForm.setErrors(err.response.data.errors);
            if (Object.keys(err.response.data.errors).includes('phone')) {
              this.phoneError = true;
            }
          }
          this.loadingUpdate = false
        })
    },
    updatePrivacy() {
      this.loadingUpdate = true

      let params = {
        privacy_policy: this.user.agency.settings.privacy_policy,
        terms_of_service: this.user.agency.settings.terms_of_service,
        setting_form: 'privacy'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          this.loadingUpdate = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.privacyForm.setErrors(err.response.data.errors)
          }
          this.loadingUpdate = false
        })
    },
    updateSmtp() {
      this.loadingUpdate = true

      let params = {
        host: this.user.agency.smtp.host,
        port: this.user.agency.smtp.port,
        username: this.user.agency.smtp.username,
        password: this.user.agency.smtp.password,
        encryption: this.user.agency.smtp.encryption ?? null,
        from_email: this.user.agency.smtp.from_email,
        from_name: this.user.agency.smtp.from_name,
        setting_form: 'smtp'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then((res) => {
          this.user.agency.smtp = res.agency.smtp;
          this.loadingUpdate = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.privacyForm.setErrors(err.response.data.errors)
          }
          this.loadingUpdate = false
        })
    },
    deleteSmtp() {
      this.loadingUpdate = true

      let params = {
        user_id: this.user.agency.ower_id,
        setting_form: 'delete_smtp'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then((res) => {
          console.log(res);
          this.user.agency.smtp = res.agency.smtp;
          this.loadingUpdate = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.privacyForm.setErrors(err.response.data.errors)
          }
          this.loadingUpdate = false
        })
    },
    updateZenEmails() {
      this.savingZenEmail = true

      let params = {
        zen_email_name: this.user.agency.settings.zen_email_name,
        zen_email_address: this.user.agency.settings.zen_email_address,
        zen_email_message: this.user.agency.settings.zen_email_message,
        zen_email_subject: this.user.agency.settings.zen_email_subject,
        setting_form: 'zen_emails'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          this.savingZenEmail = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.privacyForm.setErrors(err.response.data.errors)
          }
          this.savingZenEmail = false
        })
    },
    updateLMEmails() {
      this.savingLMEmail = true

      let params = {
        lm_email_name: this.user.agency.settings.lm_email_name,
        lm_email_address: this.user.agency.settings.lm_email_address,
        lm_email_message: this.user.agency.settings.lm_email_message,
        lm_email_subject: this.user.agency.settings.lm_email_subject,
        setting_form: 'lm_emails'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          this.savingLMEmail = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.privacyForm.setErrors(err.response.data.errors)
          }
          this.savingLMEmail = false
        })
    },
    updateEmails() {
      this.loadingUpdate = true

      let params = {
        email_name: this.user.agency.settings.email_name,
        email_address: this.user.agency.settings.email_address,
        email_message: this.user.agency.settings.email_message,
        email_subject: this.user.agency.settings.email_subject,
        setting_form: 'emails'
      }

      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          this.loadingUpdate = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.privacyForm.setErrors(err.response.data.errors)
          }
          this.loadingUpdate = false
        })
    },
    handleExplain() {
      this.showDomainModal = true
    },
    updateTwilioSettings() {
      this.loadingSave = true

      const requestParam = {
        agency_id: this.user.agency.id,
        settings: this.buildTwilioSettingsPayload()
      }
      this.$store
        .dispatch('agency/editTwilioSettings', requestParam)
        .then(() => {
          this.loadingSave = false;
        })
        .catch((err) => {
          console.error(err);
          this.loadingSave = false;
          this.$toast.error(this.twilioSettingsErrorMessage(err));
        })
    },
    changePassword() {
      this.loadingPassword = true;
      this.$store
        .dispatch('auth/changePassword', {
          password: this.password.password,
          password_confirmation: this.password.password_confirmation
        })
        .then(() => {
          this.loadingPassword = false;
          this.password.password = '';
          this.password.password_confirmation = '';
          this.$toast.success('Password changed successfully');
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.errors) {
            this.$refs.passwordForm.setErrors(err.response.data.errors);
          }
          this.loadingPassword = false;
        });
    },
    handleFaviconUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.faviconFileName = file.name;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.faviconPreview = e.target.result;
        };
        reader.readAsDataURL(file);
        
        // Upload to backend
        this.uploadDomainImage(file, 'favicon');
      }
    },
    handleLogoUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.logoFileName = file.name;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.logoPreview = e.target.result;
        };
        reader.readAsDataURL(file);
        
        // Upload to backend
        this.uploadDomainImage(file, 'logo');
      }
    },
    uploadDomainImage(file, imageType) {
      // Get domain ID - check both paths for compatibility
      let domainId = null;
      if (this.user.agency.domains && this.user.agency.domains.length > 0) {
        domainId = this.user.agency.domains[0].id;
      } else if (this.user.agency.whitelabel && this.user.agency.whitelabel.domains && this.user.agency.whitelabel.domains.length > 0) {
        domainId = this.user.agency.whitelabel.domains[0].id;
      } else {
        this.$toast.error('Please set a domain first');
        return;
      }

      const formData = new FormData();
      // API expects 'icon' for favicon and 'logo' for logo
      if (imageType === 'favicon') {
        formData.append('icon', file);
      } else if (imageType === 'logo') {
        formData.append('logo', file);
      }
      formData.append('domainId', domainId);

      this.$store
        .dispatch('agency/editDomainImages', formData)
        .then((resp) => {
          this.$toast.success(`${imageType === 'favicon' ? 'Favicon' : 'Logo'} uploaded successfully`);
          // Refresh user data
          this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
          // Update preview from response or user data
          let domain = null;
          if (resp && resp.data && resp.data.domain) {
            domain = resp.data.domain;
          } else if (this.user.agency.domains && this.user.agency.domains.length > 0) {
            domain = this.user.agency.domains[0];
          } else if (this.user.agency.whitelabel && this.user.agency.whitelabel.domains && this.user.agency.whitelabel.domains.length > 0) {
            domain = this.user.agency.whitelabel.domains[0];
          }
          
          if (domain) {
            if (imageType === 'favicon' && domain.favicon_src) {
              this.faviconPreview = domain.favicon_src;
              this.faviconFileName = domain.favicon_src.split('/').pop() || '';
            } else if (imageType === 'logo' && domain.logo_src) {
              this.logoPreview = domain.logo_src;
              this.logoFileName = domain.logo_src.split('/').pop() || '';
            }
          }
        })
        .catch((err) => {
          this.$toast.error(`Error uploading ${imageType}`);
          console.error(err);
        });
    },
    deleteDomain() {
      this.domainInput = '';
      this.faviconPreview = null;
      this.faviconFileName = '';
      this.logoPreview = null;
      this.logoFileName = '';
      if (this.$refs.faviconInput) this.$refs.faviconInput.value = '';
      if (this.$refs.logoInput) this.$refs.logoInput.value = '';
    },
    updateDomainSettings() {
      if (!this.domainInput) {
        this.$toast.error('Please enter a domain name');
        return;
      }

      this.loadingUpdate = true;
      
      // Get domain ID if it exists - check both paths for compatibility
      let domainId = null;
      if (this.user.agency.domains && this.user.agency.domains.length > 0) {
        domainId = this.user.agency.domains[0].id;
      } else if (this.user.agency.whitelabel && this.user.agency.whitelabel.domains && this.user.agency.whitelabel.domains.length > 0) {
        domainId = this.user.agency.whitelabel.domains[0].id;
      }

      const params = {
        domain: this.domainInput,
        domain_id: domainId,
        setting_form: 'domain'
      };

      this.$store
        .dispatch('agency/editSettings', params)
        .then((resp) => {
          this.loadingUpdate = false;
          this.$toast.success('Domain settings updated successfully');
          // Refresh user data
          this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
          // Update domain input and previews if domain was created/updated
          if (resp && resp.data && resp.data.agency) {
            let domain = null;
            if (resp.data.agency.domains && resp.data.agency.domains.length > 0) {
              domain = resp.data.agency.domains[0];
            } else if (resp.data.agency.whitelabel && resp.data.agency.whitelabel.domains && resp.data.agency.whitelabel.domains.length > 0) {
              domain = resp.data.agency.whitelabel.domains[0];
            }
            
            if (domain) {
              this.domainInput = domain.domain || this.domainInput;
              if (domain.favicon_src) {
                this.faviconPreview = domain.favicon_src;
                this.faviconFileName = domain.favicon_src.split('/').pop() || '';
              }
              if (domain.logo_src) {
                this.logoPreview = domain.logo_src;
                this.logoFileName = domain.logo_src.split('/').pop() || '';
              }
            }
          }
        })
        .catch((err) => {
          this.loadingUpdate = false;
          if (err.response && err.response.data && err.response.data.message) {
            this.$toast.error(err.response.data.message);
          } else if (err.response && err.response.data && err.response.data.errors) {
            // Handle validation errors
            const errors = err.response.data.errors;
            const errorMessages = Object.values(errors).flat();
            this.$toast.error(errorMessages.join(', ') || 'Error updating domain settings');
          } else {
            this.$toast.error('Error updating domain settings');
          }
        });
    },
    openFaviconFileInput() {
      if (this.$refs.faviconInput) {
        this.$refs.faviconInput.value = '';
        this.$refs.faviconInput.click();
      }
    },
    openLogoFileInput() {
      if (this.$refs.logoInput) {
        this.$refs.logoInput.value = '';
        this.$refs.logoInput.click();
      }
    },
    removeFavicon() {
      this.faviconPreview = null;
      this.faviconFileName = '';
      if (this.$refs.faviconInput) this.$refs.faviconInput.value = '';
      this.$toast.info('Favicon removed. Save domain to persist, or upload a new image.');
    },
    removeLogo() {
      this.logoPreview = null;
      this.logoFileName = '';
      if (this.$refs.logoInput) this.$refs.logoInput.value = '';
      this.$toast.info('Logo removed. Save domain to persist, or upload a new image.');
    },
    toggleEditStripeKey() {
      this.editStripeKey = !this.editStripeKey;
      
      if (this.editStripeKey) {
        // When enabling edit mode, show the full key if available
        if (this.user.agency.settings && this.user.agency.settings.stripe_api_key) {
          this.stripeApiKey = this.user.agency.settings.stripe_api_key;
        } else {
          this.stripeApiKey = '';
        }
      } else {
        // When disabling edit mode, mask the key again
        if (this.stripeApiKey && !this.stripeApiKey.includes('****')) {
          // Save the full key first
          const fullKey = this.stripeApiKey;
          // Then mask it for display
          if (fullKey.length > 8) {
            this.stripeApiKey = fullKey.substring(0, 4) + '****' + fullKey.substring(fullKey.length - 4);
          }
        }
      }
    },
    toggleNotification(type) {
      // Toggle the value
      if (type === 'initial_searches') {
        this.user.agency.settings.notify_initial_searches = !this.user.agency.settings.notify_initial_searches;
      } else if (type === 'new_leads') {
        this.user.agency.settings.notify_new_leads = !this.user.agency.settings.notify_new_leads;
      }

      // Save immediately
      const params = {
        company_name: this.user.agency.name,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone_number,
        email: this.user.email,
        address: this.user.address,
        notify_initial_searches: this.user.agency.settings.notify_initial_searches,
        notify_new_leads: this.user.agency.settings.notify_new_leads,
        powered_by_link: this.user.agency.settings.powered_by_link,
        setting_form: 'settings'
      };

      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          // Refresh user data
          this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
        })
        .catch((err) => {
          // Revert on error
          if (type === 'initial_searches') {
            this.user.agency.settings.notify_initial_searches = !this.user.agency.settings.notify_initial_searches;
          } else if (type === 'new_leads') {
            this.user.agency.settings.notify_new_leads = !this.user.agency.settings.notify_new_leads;
          }
          console.error('Error saving notification setting:', err);
        });
    },
    async saveAllApiSettings() {
      this.loadingSave = true;
      const errors = [];
      
      try {
        // Save Stripe API Key if provided and edited
        if (this.editStripeKey && this.stripeApiKey) {
          // Only save if the key doesn't contain masked characters (****)
          if (!this.stripeApiKey.includes('****')) {
            try {
              await this.$store.dispatch('agency/editSettings', {
                stripe_api_key: this.stripeApiKey,
                setting_form: 'stripe_api_key'
              });
              this.editStripeKey = false;
              // Refresh user data to get the masked version
              this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
              if (this.user.agency.settings && this.user.agency.settings.stripe_api_key) {
                const key = this.user.agency.settings.stripe_api_key;
                if (key.length > 8) {
                  this.stripeApiKey = key.substring(0, 4) + '****' + key.substring(key.length - 4);
                }
              }
            } catch (err) {
              errors.push('Stripe API Key: ' + (err.response?.data?.message || 'Invalid API key'));
            }
          }
        }

        // Save Twilio and SendGrid settings
        if (this.user.agency.twilio_settings) {
          try {
            await this.$store.dispatch('agency/editTwilioSettings', {
              agency_id: this.user.agency.id,
              settings: this.buildTwilioSettingsPayload()
            });
            this.isTwilioDisabled = true;
            this.isSendGridDisabled = true;
          } catch (err) {
            errors.push('Twilio/SendGrid: ' + this.twilioSettingsErrorMessage(err));
          }
        }

        // Save OpenAI API Key if provided (not a masked placeholder from the integrations tab)
        if (
          this.user.agency.settings.openai_api_key &&
          !this.isMaskedSecret(this.user.agency.settings.openai_api_key)
        ) {
          try {
            await this.$store.dispatch('agency/editSettings', {
              openai_api_key: this.user.agency.settings.openai_api_key,
              setting_form: 'openai'
            });
            this.aiDisabled = true;
          } catch (err) {
            errors.push('OpenAI API Key: ' + (err.response?.data?.message || 'Error saving API key'));
          }
        }

        // Refresh user data from store
        this.user = Vue.util.extend({}, this.$store.getters['auth/user']);

        this.loadingSave = false;
        
        if (errors.length > 0) {
          this.$toast.error('Some settings could not be saved: ' + errors.join(', '));
        } else {
          this.$toast.success('API settings saved successfully');
        }
      } catch (err) {
        this.loadingSave = false;
        this.$toast.error('Error saving API settings');
      }
    },
  },
}
</script>

<style lang="scss">
.settingsPage {
  /* White-label favicon/logo previews: fixed size, image never overflows */
  .overflow-hidden img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }

  .boxFile {
    .input-group {
      background-color: #4284f4;
      border-color: 1px solid #4284f4;
      border-radius: 0.3rem;
      color: #fff;

      input[type='file'] {
        cursor: pointer;
      }

      &::before {
        position: absolute;
        top: 9px;
        left: calc(50% - 45px);
        font-weight: 600;
        color: #fff;
        pointer-events: none;
        content: 'Upload File';
      }

      &:hover {
        background-color: #1e6cf2;
        border-color: #1265f1;

        &::before {
          color: #fff;
        }
      }
    }

    .form-control {
      opacity: 0;
    }
  }

  // Modern tabs styling
  .modern-tabs {
    border: none !important;

    .bg-muted {
      background-color: rgba(0, 0, 0, 0.05);
    }

    button[role="tab"] {
      cursor: pointer;
      border: none !important;

      &:hover {
        background-color: rgba(0, 0, 0, 0.03);
      }

      &.bg-background {
        background-color: #ffffff;
      }
    }
  }

  // Grid utilities
  .grid {
    display: grid;
  }

  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  @media (min-width: 768px) {
    .md\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .md\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  // Modern pagination styles
  ::v-deep .modern-pagination {
    .pagination {
      display: flex;
      gap: 0.5rem;
      margin: 0;

      .page-item {
        .page-link {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 2.25rem;
          height: 2.25rem;
          padding: 0.5rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 500;
          border-radius: 0.375rem;
          border: 1px solid #d1d5db;
          background-color: #ffffff;
          color: #111;
          transition: all 0.15s ease;

          &:hover {
            background-color: rgba(0, 0, 0, 0.05);
            color: #111;
          }
        }

        &.active .page-link {
          background-color: rgb(36, 99, 235);
          border-color: rgb(36, 99, 235);
          color: #ffffff;

          &:hover {
            background-color: rgba(36, 99, 235, 0.9);
          }
        }

        &.disabled .page-link {
          pointer-events: none;
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }

  // Negative margins
  .-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  // Space utilities
  .space-y-6>*+* {
    margin-top: 1.5rem;
  }

  .space-y-4>*+* {
    margin-top: 1rem;
  }

  // Card styling
  .bg-card {
    background-color: #ffffff;
  }

  .border-border {
    border-color: rgba(0, 0, 0, 0.1);
  }

  // Text color overrides
  .text-foreground {
    color: #111;
  }

  .text-muted-foreground {
    color: rgba(108, 117, 125, 0.9);
  }

  // Remove borders from all buttons
  button {
    border: none !important;
  }

  // Toggle switch padding
  button[role="switch"] {
    padding: 2px !important;
  }

  // Hidden utility
  .hidden {
    display: none !important;
  }
}

#MazPhoneNumberInput {
  .select-country-container {
    flex: 0 0 85px;
    width: 85px;
    min-width: 85px;
    max-width: 85px;
  }

  label.input-tel__label,
  label.country-selector__label {
    color: #4b4b5a !important;
    font-weight: normal;
  }
}
</style>
